import { createFavouriteCategoriesService } from './favouriteCategoriesService';
import localStorageService from './localStorageService';
export const favouriteCategoriesService = createFavouriteCategoriesService(localStorageService);
